<ng-content select="sb-accordion-header"></ng-content>
<div role="region" [id]="contentId()" [attr.aria-labelledby]="headerId()" [class]="regionClasses()">
  <div [attr.tabindex]="expanded() ? null : -1" [attr.inert]="!expanded() || null" [class]="clipClasses()">
    <div [class]="contentClasses()">
      <ng-content></ng-content>
    </div>
  </div>
</div>
